import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { meldPaginaweergave } from "../../lib/analytics";

/**
 * Meldt elke routewissel als paginaweergave aan Google Analytics.
 *
 * Rendert niets. De eerste route slaan we over: die is al geteld door de
 * `config`-oproep op het moment dat de meting startte. Zonder toestemming doet
 * `meldPaginaweergave` niets.
 */
export default function AnalyticsRoutes() {
  const location = useLocation();
  const eersteRoute = useRef(true);

  useEffect(() => {
    if (eersteRoute.current) {
      eersteRoute.current = false;
      return;
    }
    meldPaginaweergave(location.pathname);
  }, [location]);

  return null;
}
